export enum Environment {
    LOCAL = 'local',
    FEATURE = 'feature',
    DEVELOPMENT = 'development',
    TESTING = 'testing',
    STAGING = 'staging',
    PRODUCTION = 'production',
    PERF = 'perf'
}
